var responsiveflag = false;

$(document).ready(function () {
    responsiveResize();
    accordionVerticalMenuEnable();
    $(window).resize(responsiveResize);
    backtotop();
    addMenuListeners();
});

var product = {};

function scrollCompensate() {
    var inner = document.createElement('p');
    inner.style.width = "100%";
    inner.style.height = "200px";

    var outer = document.createElement('div');
    outer.style.position = "absolute";
    outer.style.top = "0px";
    outer.style.left = "0px";
    outer.style.visibility = "hidden";
    outer.style.width = "200px";
    outer.style.height = "150px";
    outer.style.overflow = "hidden";
    outer.appendChild(inner);

    document.body.appendChild(outer);
    var w1 = inner.offsetWidth;
    outer.style.overflow = 'scroll';
    var w2 = inner.offsetWidth;
    if (w1 == w2) w2 = outer.clientWidth;

    document.body.removeChild(outer);

    return (w1 - w2);
}

function responsiveResize() {
    compensante = scrollCompensate();
    if (($(window).width() + scrollCompensate()) <= 767 && responsiveflag == false) {
        accordionFooter('enable');
        responsiveflag = true;
    } else if (($(window).width() + scrollCompensate()) >= 768) {
        accordionFooter('disable');
        responsiveflag = false;
    }
}

function addMenuListeners() {
    $('[data-toggle="offcanvas"]').click(function (event) {
        if (($(window).width()) <= 992) {
            var menuCanvas = $(this).data('target');
            $(this).toggleClass('open');
            $(menuCanvas).toggleClass('active');
            $('body').toggleClass('off-canvas-active');
            var heightCanvas = $(window).height();
            $(menuCanvas).css({
                'min-height': heightCanvas
            });
            const overlay = document.querySelector('.off-canvas-overlay');
            overlay.classList.toggle('active');
            event.stopPropagation();
        }
    });

    $('.off-canvas-nav').click(function () {
        if (($(window).width()) <= 992) {
            $('[data-toggle="offcanvas"]').click();
        }
    });

    $('[data-toggle="offcanvasaccount"]').click(function (event) {
        if (($(window).width()) <= 992) {
            var accountCanvas = $(this).data('target');
            $(this).toggleClass('open');
            $(accountCanvas).toggleClass('active');
            $('body').toggleClass('off-canvas-active');
            var heightCanvas = $(window).height();
            $(accountCanvas).css({
                'min-height': heightCanvas
            });
            event.stopPropagation();
        }
    });

    $('.account-nav-close').click(function () {
        if (($(window).width()) <= 992) {
            $('[data-toggle="offcanvasaccount"]').click();
        }
    });

    $('#page').click(function () {
        if (($(window).width()) <= 992) {
            if ($('body').hasClass('off-canvas-active')) {
                $('[data-toggle="offcanvas"]').click();
            }
        }
    });

    $('.off-canvas-overlay').click(function () {
        if (($(window).width()) <= 992) {
            $('[data-toggle="offcanvas"]').click();
        }
    });
}

function accordionVerticalMenuEnable() {
    if (($(window).width()) > 992) {
        accordionVerticalMenu('disable');
    } else {
        accordionVerticalMenu('enable');
    }
}

function accordionFooter(status) {
    if (status == 'enable') {
        if (!$('.footer_quicklink').hasClass('accordion')) {
            $('.footer_quicklink .title_block').on('click', function () {
                $(this).toggleClass('active').parent().find('.block_content').stop().slideToggle('medium');
            })
        }
        $('.footer_quicklink').addClass('accordion').find('.block_content').slideUp('fast');
        $('.col-md-3:nth-child(1) .footer_quicklink .title_block').addClass('active').parent().find('.block_content').removeAttr('style').slideDown('fast');
    } else {
        $('.footer_quicklink .title_block').removeClass('active').off().parent().find('.block_content').removeAttr('style').slideDown('fast');
        $('.footer_quicklink').removeClass('accordion');
    }
}

function accordionVerticalMenu(status) {
    if (status == 'enable') {
        if (!$('#apollo-verticalmenu').hasClass('accordion')) {
            $('#apollo-verticalmenu .title_block').on('click', function () {
                $(this).toggleClass('active').parent().find('.block_content').stop().slideToggle('medium');
            })
        }
        $('#apollo-verticalmenu').addClass('accordion').find('.block_content').slideUp('fast');
    } else {
        $('#apollo-verticalmenu .title_block').removeClass('active').off().parent().find('.block_content').removeAttr('style');
        $('#apollo-verticalmenu').removeClass('accordion');
    }
}

function addClassActive(e) {
    $(e).addClass('active');
    if (!$(e).parent().hasClass('megamenu')) {
        addClassActive($(e).parent().closest('li'));
    }
}

function backtotop() {
    $("#back-top").hide();
    $(function () {
        $(window).scroll(function () {
            if ($(this).scrollTop() > 100) {
                $('#back-top').fadeIn();
            } else {
                $('#back-top').fadeOut();
            }
        });
        $('#back-top a').click(function () {
            $('body,html').animate({
                scrollTop: 0
            }, 800);
            return false;
        });
    });
}
